<mat-card appearance="outlined">
  <a [href]="link" (click)="openApplication($event)">
    <div mat-card-image class="appIcon">
      <ng-content></ng-content>
    </div>
    <mat-card-header>
      <mat-card-title>
        {{ title | translate: { default: application.name } }}
      </mat-card-title>
      <mat-card-subtitle>
        {{ subtitle | translate: { default: application.tooltip } }}
      </mat-card-subtitle>
    </mat-card-header>
  </a>
</mat-card>
